/**
 * @param {import("../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/files",
    },
    (router) => {
      router.push({
        id: "@api/files@create",
        path: "",
      });
    },
  );
}
